<template>
  <div>
    <Header v-if="!$store.getters.isApp" :title="$route.meta.title" :left-hide="!$route.query.isHistory" />

    <ResultBankNoSteps
      :message="message"
      :name="name"
      :status="status"
      :trade-type="tradeType"
      :is-history="$route.query.isHistory"
    >
      <ResultBankInfo :transfer-info="bankContent" />
    </ResultBankNoSteps>
  </div>
</template>

<script>
import { tradeDetail } from '@/api/withdraw'
import ResultBankInfo from '@/components/ResultBankInfo'
import ResultBankNoSteps from '@/components/ResultBankNoSteps'
import Header from '@/components/Header'

export default {
  name: 'HaveNoStepsDetail',

  components: {
    ResultBankInfo,
    ResultBankNoSteps,
    Header
  },

  data () {
    return {
      bankContent: {},
      message: '',
      name: '',
      status: '',
      tradeType: ''
    }
  },

  mounted () {
    const { tradeNo, path } = this.$route.query
    this.name = path
    tradeNo && this.fetchData(tradeNo)
  },

  methods: {
    async fetchData (tradeNo) {
      const data = await tradeDetail({ tradeNo })
      this.status = data.status
      this.bankContent = { ...data }
      this.message = data.retMessage
      this.tradeType = data.tradeType
    }
  }
}
</script>
